__turbopack_context__.v({
  "buttonWrapper": "BottomButton-module-scss-module__W_H6oq__buttonWrapper",
});
